// 像框选择
<template>
	<div v-if="showFlag" class="am-container">
		<div class="acm-box">
			<div class="acmb-c">
				<div class="_title-ac">制作你的专属新年头像吧!</div>
				<template>
					<div v-for="(item, index) in dataList" :key="index">
						<div :class="['header', item.headerClass]"></div>
						<div class="content">
							<div class="c-item" @click="xkClick(index, 0)">
								<div
									class="img_div"
									:class="activeId == item.items[0].id ? 'active-img' : ''"
								>
									<img :src="item.items[0].img" />
								</div>
							</div>
							<div class="line-c"></div>
							<div class="c-item" @click="xkClick(index, 1)">
								<div
									class="img_div"
									:class="activeId == item.items[1].id ? 'active-img' : ''"
								>
									<img :src="item.items[1].img" />
								</div>
							</div>
							<div class="line-c"></div>
							<div class="c-item" @click="xkClick(index, 2)">
								<div
									class="img_div"
									:class="activeId == item.items[2].id ? 'active-img' : ''"
								>
									<img :src="item.items[2].img" />
								</div>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
		<div class="opt-area">
			<div class="next-btn" @click="nextClick"></div>
		</div>
	</div>
</template>
<script>
	const xk_01 = '/style/assets/image/p3/xk/01.png'
	const xk_02 = '/style/assets/image/p3/xk/02.png'
	const xk_03 = '/style/assets/image/p3/xk/03.png'
	const xk_04 = '/style/assets/image/p3/xk/04.png'
	const xk_05 = '/style/assets/image/p3/xk/05.png'
	const xk_06 = '/style/assets/image/p3/xk/06.png'
	const xk_07 = '/style/assets/image/p3/xk/07.png'
	const xk_08 = '/style/assets/image/p3/xk/08.png'
	const xk_09 = '/style/assets/image/p3/xk/09.png'
	const xk_10 = '/style/assets/image/p3/xk/10.png'
	const xk_11 = '/style/assets/image/p3/xk/11.png'
	const xk_12 = '/style/assets/image/p3/xk/12.png'
	export default {
		data() {
			return {
				dataList: [
					{
						headerClass: 'header_1',
						items: [
							{
								id: 1,
								img: xk_01,
								width: '95%',
								heigth: '95%',
								position: 'right',
								selected: false,
								cHeight: '1.65rem',
								cWidth: '1.8rem',
							},
							{
								id: 2,
								img: xk_02,
								width: '95%',
								heigth: '95%',
								position: 'left',
								selected: false,
								cHeight: '1.533rem',
								cWidth: '1.6rem',
							},
							{
								id: 3,
								img: xk_03,
								width: '95%',
								heigth: '95%',
								position: 'right',
								selected: false,
								cHeight: '1.533rem',
								cWidth: '1.6rem',
							},
						],
					},
					{
						headerClass: 'header_2',
						items: [
							{
								id: 4,
								img: xk_04,
								width: '95%',
								heigth: '95%',
								position: 'left',
								selected: false,
								cHeight: '1.6rem',
								cWidth: '1.73333rem',
							},
							{
								id: 5,
								img: xk_05,
								width: '95%',
								heigth: '95%',
								position: 'left',
								selected: false,
								cHeight: '1.6rem',
								cWidth: '1.73333rem',
							},
							{
								id: 6,
								img: xk_06,
								width: '95%',
								heigth: '95%',
								position: 'left',
								selected: false,
								cHeight: '1.6rem',
								cWidth: '1.73333rem',
							},
						],
					},
					{
						headerClass: 'header_3',
						items: [
							{
								id: 7,
								img: xk_07,
								width: '95%',
								heigth: '95%',
								position: 'right',
								selected: false,
								cHeight: '1.6rem',
								cWidth: '1.8rem',
							},
							{
								id: 8,
								img: xk_08,
								width: '95%',
								heigth: '95%',
								position: 'right',
								selected: false,
								cHeight: '1.6rem',
								cWidth: '1.75rem',
							},
							{
								id: 9,
								img: xk_09,
								width: '95%',
								heigth: '95%',
								position: 'right',
								selected: false,
								cHeight: '1.5rem',
								cWidth: '1.73333rem',
							},
						],
					},
					{
						headerClass: 'header_4',
						items: [
							{
								id: 10,
								img: xk_10,
								width: '95%',
								heigth: '95%',
								position: 'right',
								selected: false,
								cHeight: '1.6rem',
								cWidth: '1.73333rem',
							},
							{
								id: 11,
								img: xk_11,
								width: '94%',
								heigth: '94%',
								position: 'left',
								selected: false,
								cHeight: '1.55rem',
								cWidth: '1.7rem',
							},
							{
								id: 12,
								img: xk_12,
								width: '95%',
								heigth: '95%',
								position: 'right',
								selected: false,
								cHeight: '1.55rem',
								cWidth: '1.7rem',
							},
						],
					},
				],
				currentItem: {},
				activeId: '',
				showFlag: false,
			}
		},
		created() {
			let vdata = localStorage.getItem('vdata')
			if (vdata) {
				this.showFlag = true
			}
		},
		methods: {
			xkClick(index, cIdex) {
				let item = this.dataList[index].items[cIdex]
				this.activeId = item.id
				this.currentItem = item
			},
			nextClick() {
				if (!this.activeId) {
					this.$toast('请选择专属头像')
					return
				}
				localStorage.removeItem('avatarMaking')
				this.$router.replace({
					name: 'avatarMaking',
					params: this.currentItem,
				})
			},
		},
	}
</script>
<style lang="scss" scoped>
	.am-container {
		z-index: 100;
		width: 10rem;
		// height: calc(100vh - 3.333333rem);
		height: calc(100vh - 2rem);
		background: url('/style/assets/image/p3/bg.png') #e7343a
			no-repeat;
		background-size: 100% 16.8rem;
		// padding-top: 3.333333rem;
		padding-top: 2rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		.acm-box {
			// width: 7.12rem;
			// height: 11.8rem;
			width: 9.12rem;
			height: 12.8rem;
			background: url('/style/assets/image/p3/bg2.png')
				no-repeat;
			background-size: 100% 100%;
			margin-bottom: 0.533333rem;
			.acmb-c {
				padding-top: 1.6rem;
				position: relative;
				._title-ac {
					font-family: 'webfont' !important;
					position: absolute;
					top: 0;
					left: 0;
					height: 1.45rem;
					font-size: 0.5rem;
					font-weight: 600;
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					color: #64360d;
				}
				.header {
					width: 100%;
					height: 0.8rem;
				}
				.header_1 {
					background: url('/style/assets/image/p3/xlxy.png')
						center center no-repeat;
					// background: url('../assets/image/xlxy.png') center center no-repeat;
					background-size: 2.666667rem 100%;
				}
				.header_2 {
					background: url('/style/assets/image/p3/rxjp.png')
						center center no-repeat;
					// background: url('../assets/image/rxjp.png') center center no-repeat;
					background-size: 2.666667rem 100%;
				}
				.header_3 {
					background: url('/style/assets/image/p3/lhjs.png')
						center center no-repeat;
					// background: url('../assets/image/lhjs.png') center center no-repeat;
					background-size: 2.666667rem 100%;
				}
				.header_4 {
					// background: url('/style/assets/image/p3/mhsh.png')
					// 	center center no-repeat;
					background: url('../assets/image/mhsh.png') center center no-repeat;
					background-size: 2.666667rem 100%;
				}
				.content {
					height: 1.8rem;
					width: 100%;
					display: flex;
					.line-c {
						width: 0.04rem;
						height: 100%;
						background: url('/style/assets/image/p3/fgx.png')
							center center no-repeat;
						background-size: 2.666667rem 80%;
					}
					.c-item {
						width: 33.33%;
						height: 100%;
						// border: 1px solid;
						display: flex;
						align-items: center;
						justify-content: center;
						margin-top: 0.1rem;
						.img_div {
							position: relative;
						}
						img {
							height: 1.6rem;
							width: 1.6rem;
							// position: relative;
						}
						.active-img::before {
							content: '';
							position: absolute;
							height: 0.6rem;
							width: 0.6rem;
							bottom: 0;
							right: -0.2rem;
							background: url('/style/assets/image/p3/select.png')
								no-repeat;
							background-size: 100% 100%;
						}
					}
				}
			}
		}
		.opt-area {
			width: 100%;
			// height: 1.346667rem;
			height: 1.84rem;
			display: flex;
			align-items: center;
			justify-content: center;
			background: url('/style/assets/image/btn_bg_t.png')
				no-repeat;
			background-size: 100% 100%;
			.next-btn {
				height: 1.346667rem;
				width: 3.56rem;
				background: url('/style/assets/image/p3/next-btn.png')
					no-repeat;
				background-size: 100% 100%;
			}
		}
	}
</style>
